import Sidebar from "../../components/Sidebar";
import React, {useEffect, useState} from "react";
import {RiArrowDownSFill, RiArrowUpSFill, RiExpandUpDownFill} from "react-icons/ri";
import {accountInfo, lastMonth, lastWeek, today, yesterday} from "../../constants/constants";
import neverLandUtils from "../../utils/NeverLandUtils";
import {toast} from "react-toastify";
import ListSelectBox from "../../components/ListSelectBox";
import Pagination from "../../components/Pagination/Pagination";
import DatePickerInput from "../../components/DatePickerInput";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {ko} from "date-fns/locale";
import {getFetcher} from "../../utils/fetcher";
import PangSendModal from "./modal/PangSendModal";
import MyStoreHeader from "../../components/Header/MyStoreHeader";


const StorePangHistoryPage = () => {
    const CurrentPageConstants = {
        Title: "추천인 팡 내역",
        Text: "나와 나를 추천인으로 지정한 친구들의 팡 사용내역이 표시됩니다.",
        Key: "StorePangHistoryPage",
        SourceType: "store",

        LIST_API: "/bonaint/store/sub_user_pang_histories",

        FixedCondition: '',

        FilterOption: [
            {name: "전체", code: "all"},
            {name: "ID", code: "concerned_member02*"},
            {name: "닉네임", code: "nick_name"},
            {name: "추천인", code: "store_code"},
            {name: "날짜별", code: "create_time"},
        ],

        DisplayContents: [
            // {title: "보유 팡", mobileHidden: false, useOrderKey: false, dataKey: "currentPang￦"},
            // {title: "보유 팡", mobileHidden: false, useOrderKey: false, dataKey: "currentPang"},
            // {title: "보유 팡", mobileHidden: false, useOrderKey: false, dataKey: "currentPang"},
            // {title: "보유 팡", mobileHidden: false, useOrderKey: false, dataKey: "currentPang"},
        ],
        DisplayColumns: [
            {title: "일자", mobileHidden: false, useOrderKey: false, dataKey: "createDate⒟"},
            {title: "시간", mobileHidden: false, useOrderKey: false, dataKey: "createDate⒯"},
            {title: "송신자", mobileHidden: false, useOrderKey: false, dataKey: "historySenderCode[0]"},
            {title: "수신자", mobileHidden: false, useOrderKey: false, dataKey: "displayHistoryTargetCode"},
            {title: "내역", mobileHidden: false, useOrderKey: false, dataKey: "historyText￦"},
            {title: "보유 팡", mobileHidden: false, useOrderKey: false, dataKey: "currentPang￦"},
            {title: "구분", mobileHidden: false, useOrderKey: false, dataKey: "historyType"}
        ],

        ModalOption: {
            ModalActionText: "",
            UseModal(data) {
                return true;
            },
            CreateModalOpen: (closeModal, currentInfo) => {
                return <div/>;
            },

            GetModalContentText:(index, key)=>{
                if(key==='currentPang￦')
                    return "팡 선물하기";
                return null;
            },
            ConvertKey:(key)=>{
                return key;
            },
            CreateContentsModalOpen: (closeModal, key, value) => {
                return <div/>;
            },
            HasModalContentText(index,size, key) {
                return true;
            }
        },
        CurrentPageHeader : ()=>{
            return <MyStoreHeader/>;
        },
        ConvertList: (list) => {
            return list;
        },
        GetListFromResult: (result) => {
            console.log('GetListFromResult', result);
            return result.list;
        },
        GetContentData(result) {
            // console.log('GetContentData', result);
            // return [
            //     {key: 'currentPang', value: result.result.currentPang}
            // ];
            return null;
        }
    };
    const getContentData=(currentKey,defaultValue)=> {
        if(contentsDatas){
            for(let c of contentsDatas){
                if(c.key===currentKey)
                    return c.value;
            }
        }
        return defaultValue;
    }
    const initialize = ()=>{
        CurrentPageConstants.ModalOption.ConvertKey =(amount)=>{
            console.log('MyPangHistoryPage.ConvertKey('+amount+")");
            return {currentPang:amount, targetType:'store', sourceType:CurrentPageConstants.SourceType};
        };
        CurrentPageConstants.ModalOption.CreateModalOpen =(closeModal, currentInfo)=>{
            return <PangSendModal closeMatchModal={closeModal} sendPangInfo={currentInfo}/>;
        };
        CurrentPageConstants.ModalOption.CreateContentsModalOpen= (closeModal, key, value) => {
            return <PangSendModal closeMatchModal={closeModal} sendPangInfo={value}/>;
        };
    };

    initialize();

    const [contentsDatas, setContentsDatas] = useState([]);
    const [currentDataList, setCurrentDataList] = useState([]);
    const [currentModalOpen, setCurrentModalOpen] = useState(false);
    const [currentInfo, setCurrentInfo] = useState(null);
    // 검색조건
    const [startDate, setStartDate] = useState(new Date(Date.parse("2023-01-01")));
    const [endDate, setEndDate] = useState(new Date());
    const [searchCondition, setSearchCondition] = useState(CurrentPageConstants.FilterOption[0]);
    const [searchConditionValue, setSearchConditionValue] = useState('');
    // 페이지네이션
    const [isLoading, setIsLoading] = useState(false); // 로딩중
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState('');
    let pageSize = 15;
    const [refreshKey, setRefreshKey] = useState(new Date());

    const makeTableHeader = (name) => {
        return (
            <div className="flex justify-center">
                <div key={name}
                     className="whitespace-nowrap px-3 text-center text-sm font-semibold text-white lg:table-cell">
                    <div className="flex items-center justify-center cursor-pointer"
                         onClick={() => makeAlignData(name)}>
                        <span>{name}</span>
                        {currentAlignData[name] !== undefined && currentAlignData[name] !== '-' ?
                            (currentAlignData[name] === "desc" ?
                                    <RiArrowDownSFill className="h-5 w-5 text-yellow-500 ml-1"/>
                                    : <RiArrowUpSFill className="h-5 w-5 text-sky-500 ml-1"/>
                            ) : <RiExpandUpDownFill className="h-4 w-4 text-gray-400 ml-1"/>
                        }
                    </div>
                </div>
            </div>);
    }

    const [currentAlignData, setCurrentAlignData] = useState(accountInfo.getAlignDataList(CurrentPageConstants.Key));

    function makeAlignData(name) {
        // <-- 테이블 오름차순/내림차순 정렬 -->
        let prevData = currentAlignData[name];
        if (prevData === undefined || prevData === "-") {
            currentAlignData[name] = "asc";
        } else if (prevData === "asc") {
            currentAlignData[name] = "desc";
        } else if (prevData === "desc") {
            currentAlignData[name] = "-";
        }
        let newAlignData = {...currentAlignData};

        accountInfo.saveAlignData(CurrentPageConstants.Key, newAlignData);

        // if (setAlignData)
        //   setAlignData(jsonDataToString(newAlignData));
        setCurrentAlignData(newAlignData);
    }

    const jsonDataToString = (obj) => {
        // <-- JSON 데이터 받아서 파라미터에 넣을 형식으로 변환하기 -->
        return Object.keys(obj).map(key => `${key}:${obj[key]}`).join('▼');
    }

    const dateFilterButton = [
        {label: '당일', onClick: () => handleDateChange(today, today)},
        {label: '전일', onClick: () => handleDateChange(yesterday, yesterday)},
        {label: '일주일', onClick: () => handleDateChange(lastWeek, today)},
        {label: '한달', onClick: () => handleDateChange(lastMonth, today)},
    ]

    const handleDateChange = (startDate, endDate) => {
        setStartDate(startDate);
        setEndDate(endDate);
    };

    function _getFormatDate() {
        let _startDate = neverLandUtils.utils.getDisplayTextByDate(startDate);
        let _endDate = neverLandUtils.utils.getDisplayTextByDate(endDate);
        return 'begin_time:' + _startDate + '▼end_time:' + _endDate;
    }

    useEffect(() => {
        getCurrentList(jsonDataToString(currentAlignData));
    }, [currentAlignData, currentPage]);

    const getCurrentList = (searchOrder) => {
        if (CurrentPageConstants.LIST_API.length == 0)
            return;

        // let searchingCondition = `registDate:${_getFormatDate()}` + '▼' + searchCondition.code + ':' + searchConditionValue;
        let _searchingCondition='all';

        if(CurrentPageConstants.FilterOption&&searchCondition&&searchCondition.code) {
            if (searchCondition.code === "create_time") {
                _searchingCondition = _getFormatDate();
            } else {
                _searchingCondition = searchCondition.code + ':' + searchConditionValue;
            }
        }

        if(CurrentPageConstants.FixedCondition&&CurrentPageConstants.FixedCondition.length>0) {
            _searchingCondition += "▼"+CurrentPageConstants.FixedCondition;
        }

        setIsLoading(true);
        getFetcher().get(accountInfo.makeGetRequest(CurrentPageConstants.LIST_API) + `&pageNumber=${currentPage}&pageSize=${pageSize}&searchCondition=${_searchingCondition}&searchOrder=${searchOrder}`)
            .then(res => {
                const {header, result} = res.data;

                if (header.type === 'success') {
                    setContentsDatas(CurrentPageConstants.GetContentData(result));

                    let list = CurrentPageConstants.GetListFromResult(result);
                    let datalist = list.content;
                    let currentPageNumber = list.pageable.pageNumber + 1;
                    if (datalist.length === 0) {
                        currentPageNumber = 1;
                    }
                    setCurrentDataList(CurrentPageConstants.ConvertList(datalist));
                    setCurrentPage(currentPageNumber);
                    setTotalPage(list.totalPages);
                    setIsLoading(false);
                    setRefreshKey(new Date());
                } else {
                    toast.error('데이터를 불러오는데 실패하였습니다.');
                }
            }).catch(err => toast.error(err.message));
    }

    const openModal = (data) => {
        setCurrentInfo({type:"data",data:data});
        setCurrentModalOpen(true);
    }

    const closeModal = (isSuccess) => {
        setCurrentModalOpen(false);
        setCurrentInfo(null);
        if(isSuccess) {
            setRefreshKey(new Date());
            getCurrentList(jsonDataToString(currentAlignData));
        }
    }

    const Modal = currentInfo&&currentInfo.type&&
        (
            currentInfo.type==="data"?
                CurrentPageConstants.ModalOption.CreateModalOpen(closeModal, currentInfo.data):
                CurrentPageConstants.ModalOption.CreateContentsModalOpen(closeModal, currentInfo.key, currentInfo.data)
        );

    function openContentsModal(dataKey, prevValue) {
        let newValue= CurrentPageConstants.ModalOption.ConvertKey(prevValue);
        setCurrentInfo({type:"contents",key:dataKey, data:newValue});
        setCurrentModalOpen(true);
    }

    return (
        <>
            {currentModalOpen && Modal}
            <Sidebar/>
            <div className="lg:pl-64">
                {CurrentPageConstants.CurrentPageHeader()}

                <main className="lg:mt-10 px-4 sm:px-6 lg:px-52 lg:py-12">
                    <div className="sm:flex sm:items-center sm:py-0">
                        <div className="sm:flex-auto">
                            <h1 className="text-xl font-semibold leading-6 text-stone-900">{CurrentPageConstants.Title}</h1>
                            <p className="mt-3 text-sm text-gray-400">
                                {CurrentPageConstants.Text}
                            </p>
                        </div>
                    </div>

                    {CurrentPageConstants.DisplayContents && CurrentPageConstants.DisplayContents.length > 0 && contentsDatas && <br/>}

                    {CurrentPageConstants.DisplayContents && CurrentPageConstants.DisplayContents.length > 0 && contentsDatas  &&
                        <table
                            className="divide-y divide-stone-300 ring-1 ring-gray-900 bg-stone-900 sm:w-1/3 w-full">

                            <tbody className="divide-y bg-white items-start"
                                   key={"contents_" + refreshKey}>
                            {CurrentPageConstants.DisplayContents?.map((value, index) => (
                                <tr key={index}
                                    className={"whitespace-nowrap text-center text-sm"}>
                                    <td className={neverLandUtils.classNames(value.mobileHidden ? "hidden sm:table-cell" : "py-3", "divide-white bg-gray-900 text-white w-1/2")}>
                                        {value.title}
                                    </td>
                                    {
                                        contentsDatas && contentsDatas.length > 0 ? contentsDatas.map((data) => {
                                                let thisDataKey=value.dataKey;
                                                if(thisDataKey.endsWith('￦')){
                                                    thisDataKey=thisDataKey.slice(0, -1);
                                                }
                                                if(thisDataKey.endsWith('⒟')){
                                                    thisDataKey=thisDataKey.slice(0, -1);
                                                }
                                                if(thisDataKey.endsWith('⒯')){
                                                    thisDataKey=thisDataKey.slice(0, -1);
                                                }
                                                if (data.key === thisDataKey) {
                                                    let html = data["value"];
                                                    if (html===undefined||html===null) {
                                                        return <td/>;
                                                        // console.log(CurrentPageConstants.LIST_API + "/" + thisDataKey + "=> undefined", data);
                                                    }
                                                    if (thisDataKey.includes("Date") && html.includes("T")) {
                                                        if(value.dataKey.endsWith("⒟")){
                                                            html = html.split('T')[0];
                                                        }
                                                        else if(value.dataKey.endsWith("⒯")){
                                                            html = html.split('T')[1].split('.')[0];
                                                        }
                                                        else {
                                                            html = html.split('T')[0];
                                                        }
                                                    }
                                                    if(value.dataKey.endsWith("￦")){
                                                        let _number= Number(html);
                                                        html = (html.toString().startsWith("+")?"+":"") + _number.toLocaleString();
                                                    }
                                                    value.prevKey=html;
                                                    return <td className={neverLandUtils.classNames(index % 2 === 1 ? "bg-gray-200" : "bg-white","py-3")}>{html}</td>
                                                }
                                            })
                                            : <td> --데이터 조회 중-- </td>
                                    }
                                    {

                                        CurrentPageConstants.ModalOption && CurrentPageConstants.ModalOption.GetModalContentText &&
                                        CurrentPageConstants.ModalOption.HasModalContentText(index, contentsDatas.length,  value.dataKey)&&
                                        (CurrentPageConstants.ModalOption.GetModalContentText(index, value.dataKey) ?
                                            <td className={neverLandUtils.classNames(index % 2 === 1 ? "bg-gray-200" : "bg-white", "py-3")}>
                                                <button
                                                    onClick={() => openContentsModal(value.dataKey, value.prevKey)}
                                                    className="bg-green-800 px-2 py-0.5 text-white rounded-md"
                                                >
                                                    {CurrentPageConstants.ModalOption.GetModalContentText(index,  value.dataKey)}
                                                </button>
                                            </td>
                                            :
                                            <td className={neverLandUtils.classNames(index % 2 === 1 ? "bg-gray-200" : "bg-white", "py-3")}>

                                            </td>)
                                    }

                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }


                    {/*데이트피커*/}
                    {(searchCondition&&searchCondition.code)?
                        <div className="text-sm my-5 flex flex-col sm:flex-row justify-start mt-5">
                            {searchCondition.code === "create_time" ?
                                <div className="flex flex-row items-center mb-3 md:mb-0">
                                    <ListSelectBox listData={CurrentPageConstants.FilterOption}
                                                   onChange={(filter) => setSearchCondition(filter)}/>
                                    <span>조회일자 :</span>
                                    <div className="ml-2 flex flex-row items-center">
                                        {dateFilterButton.map((data) => (
                                            <button
                                                key={data.label}
                                                onClick={data.onClick}
                                                className="mr-2 flex flex-row rounded-3xl bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500"
                                            >
                                                {data.label}
                                            </button>
                                        ))}
                                        <div
                                            className="mr-3 flex flex-row justify-between px-5 py-2 ring-1 ring-gray-300 rounded-3xl text-center">
                                            <DatePicker
                                                locale={ko}
                                                dateFormat='yyyy-MM-dd'
                                                selected={startDate}
                                                onChange={date => setStartDate(date)}
                                                customInput={<DatePickerInput/>}
                                            />
                                            <span className="mx-2"> ~ </span>
                                            <DatePicker
                                                locale={ko}
                                                dateFormat='yyyy-MM-dd'
                                                selected={endDate}
                                                onChange={date => setEndDate(date)}
                                                customInput={<DatePickerInput/>}
                                            />
                                        </div>
                                    </div>
                                    <button onClick={() => {
                                        getCurrentList(jsonDataToString(currentAlignData))
                                    }}
                                            className="whitespace-nowrap rounded-md bg-blue-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-800">
                                        조회
                                    </button>
                                </div> :

                                <div className="flex flex-row">
                                    <ListSelectBox listData={CurrentPageConstants.FilterOption}
                                                   onChange={(filter) => setSearchCondition(filter)}/>
                                    {searchCondition.code !== 'all' &&
                                        <input
                                            className="mr-3 w-36 px-3 py-2 ring-1 ring-gray-300 rounded-3xl focus:ring-indigo-500"
                                            onChange={(e) => setSearchConditionValue(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') getCurrentList();
                                            }}
                                        />
                                    }
                                    <button onClick={() => {
                                        getCurrentList(jsonDataToString(currentAlignData))
                                    }}
                                            className="whitespace-nowrap rounded-md bg-blue-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-800">
                                        조회
                                    </button>
                                </div>
                            }
                        </div>:<br/>
                    }



                    <table
                        className="min-w-full divide-y divide-stone-300 ring-1 ring-gray-300 rounded-lg bg-stone-900">
                        <thead>
                        <tr className="whitespace-nowrap text-white font-semibold text-sm text-center">
                            {
                                CurrentPageConstants.DisplayColumns.map((value) => {
                                    let html = value.title;
                                    if (value.useOrderKey)
                                        html = makeTableHeader(html);
                                    if (value.mobileHidden) {
                                        return <th className="hidden sm:table-cell">{html}</th>
                                    }
                                    return <th className="py-3">{html}</th>
                                })
                            }
                            <th>
                            </th>
                        </tr>
                        </thead>
                        <tbody className="divide-y divide-stone-300 bg-white" key={"contents_" + refreshKey}>
                        {currentDataList?.map((data, index) => (
                            <tr key={index}
                                className={neverLandUtils.classNames((CurrentPageConstants.DisplayColumns.SpecialValue && data[CurrentPageConstants.DisplayColumns.SpecialKey]
                                    ?.includes(CurrentPageConstants.DisplayColumns.SpecialValue))
                                    ? "hover:bg-amber-100 bg-orange-50 text-red-600"
                                    : "hover:bg-blue-50 text-stone-900", "whitespace-nowrap text-center text-sm")}>

                                {
                                    CurrentPageConstants.DisplayColumns.map((value) => {

                                        let thisDataKey=value.dataKey;
                                        if(thisDataKey.endsWith('￦')){
                                            thisDataKey=thisDataKey.slice(0, -1);
                                        }
                                        if(thisDataKey.endsWith('⒟')){
                                            thisDataKey=thisDataKey.slice(0, -1);
                                        }
                                        if(thisDataKey.endsWith('⒯')){
                                            thisDataKey=thisDataKey.slice(0, -1);
                                        }
                                        let html;


                                        if(thisDataKey.includes("[")&&thisDataKey.includes("]")){
                                            let tokens=thisDataKey.split(/\[|\]/);
                                            html = data[tokens[0].trim()];
                                            if (!html) {
                                                console.log(CurrentPageConstants.LIST_API + "/" + thisDataKey + "=> undefined1", data);
                                                return <td/>;
                                            }
                                            if(html===null){
                                                html="[UNKNOWN]";
                                            }
                                            else {
                                                html = html.split('|')[Number(tokens[1].trim())];
                                            }
                                        }
                                        else {
                                            html = data[thisDataKey];
                                        }

                                        if (html) {
                                            if (thisDataKey.includes("Date") && html.includes("T")) {
                                                if(value.dataKey.endsWith("⒟")){
                                                    html = html.split('T')[0];
                                                }
                                                else if(value.dataKey.endsWith("⒯")){
                                                    html = html.split('T')[1].split('.')[0];
                                                }
                                                else {
                                                    html = html.split('T')[0];
                                                }
                                            }
                                        }


                                        if(value.dataKey.endsWith("￦")){
                                            let _number= Number(html);
                                            if(html.toString().startsWith("+")){
                                                html = <div className="text-blue-800">+{_number.toLocaleString()}</div>;
                                            }
                                            else if(_number<=0){
                                                html = <div className="text-red-600">{_number.toLocaleString()}</div>;
                                            }
                                            else if(html.length===0){
                                                html = <div className="text-red-600">0</div>;
                                            }
                                            else{
                                                html = <div className="text-green-800">{_number.toLocaleString()}</div>;
                                            }
                                        }
                                        if (value.mobileHidden) {
                                            return <td className="hidden sm:table-cell">{html}</td>
                                        }
                                        return <td className="py-3">{html}</td>
                                    })
                                }

                                <td>

                                    {CurrentPageConstants.ModalOption && CurrentPageConstants.ModalOption.ModalActionText && CurrentPageConstants.ModalOption.ModalActionText.length > 0 && CurrentPageConstants.ModalOption.UseModal(data) &&
                                        <button
                                            onClick={() => openModal(data)}
                                            className="text-blue-600"
                                        >
                                            {CurrentPageConstants.ModalOption.ModalActionText}
                                        </button>}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>

                    {/*페이지네이션*/}
                    {currentDataList !== null && currentDataList.length !== 0 && totalPage > 1 &&
                        <div className="mt-10">
                            <Pagination
                                isLoading={isLoading}
                                totalPage={totalPage}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                        </div>
                    }
                </main>
            </div>
        </>
    )
}
export default StorePangHistoryPage;